import {PaymentInfoItem} from "./PaymentInfoItem";
import React from "react";
import {OrderRequestPrepaidDto, TOrderDetail} from "../types/types";
import {swapCancelMethod, swapPayMethod} from "../utils/texts";
import moment from "moment";

type PaymentInfoPcProps = {
    order: TOrderDetail
    prepaid?: OrderRequestPrepaidDto
}

export default (props: PaymentInfoPcProps) => {
    const {order, prepaid} = props;

    return (
        <>
            <div className="space-y-2 border-b border-gray-200 pb-4 mb-4">
                <div className="flex justify-between">
                    <p className="">총 주문 금액</p>
                    <p className="font-bold">{(order.productPrice + order.deliveryPrice).toLocaleString()}원</p>
                </div>
                <PaymentInfoItem title="상품금액" content={`${order.productPrice.toLocaleString()}원`}/>
                <PaymentInfoItem title="배송비" content={`${order.deliveryPrice.toLocaleString()}원`}/>
            </div>

            <div className="space-y-2 border-b border-gray-200 pb-4 mb-4">
                <div className="flex justify-between">
                    <p className="">총 할인 금액</p>
                    <p className="font-bold">-{order.discountPrice.toLocaleString()}원</p>
                </div>
                <PaymentInfoItem title="쿠폰" content={`-${order.couponDiscount.toLocaleString()}원`}/>
                <PaymentInfoItem title="적립금" content={`-${order.usedMileage.toLocaleString()}원`}/>
            </div>

            <div className="space-y-2">
                {prepaid ? (
                    <div className="flex justify-between mb-4">
                        <p className="">총 환불 금액</p>
                        <p className="font-semibold text-red-500">{prepaid.totalPaidProductAmount.toLocaleString()}원</p>
                    </div>
                ) : (
                    <div className="flex justify-between mb-4">
                        <p className="">총 결제 금액</p>
                        <p className="font-semibold text-red-500">{order.totalPrice.toLocaleString()}원</p>
                    </div>
                )}
                {prepaid ?
                    <PaymentInfoItem title="반환 적립금" content={`${prepaid.willReturnMileage.toLocaleString()}원`}/>
                    :
                    <PaymentInfoItem title="적립금 적립" content={`${order.earnedMileage.toLocaleString()}원`}/>
                }
                <PaymentInfoItem title="결제 수단" content={`${swapPayMethod(order.payMethod)}`}/>
                {order.payMethod === 'VIRTUAL_ACCOUNT' && (
                    <PaymentInfoItem title="예금주명" content={`${order.virtualAccountOwner}`}/>
                )}
                {prepaid ?
                    <PaymentInfoItem title="환불 처리"
                                     content={swapCancelMethod(order.payMethod)}/>
                    :
                    <PaymentInfoItem title="결제일"
                                     content={order.paidAt ? moment(order.paidAt).format(`YYYY.MM.DD`) : '결제 대기중'}/>
                }
            </div>
        </>
    )
}
